import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import User from "@/models/User";
import Group from "@/models/Group";
import Permission from "@/models/Permission";
import Coupon from "@/models/Coupon";
import CouponWelcome from "@/models/CouponWelcome";
import CouponReference from "@/models/CouponReference";
import CouponReferer from "@/models/CouponReferer";
import CouponWelcomeUser from "@/models/CouponWelcomeUser";
import CouponReferenceUser from "@/models/CouponReferenceUser";
import CouponRefererUser from "@/models/CouponRefererUser";
import Coupons from "@/models/Coupons";
import Company from "@/models/Company";
import Auth from "@/models/Auth";
import BranchOffice from "@/models/BranchOffice";
import Category from "@/models/Category";
import Payment from "@/models/Payment";
import Country from "@/models/Country";
import Region from "@/models/Region";
import City from "@/models/City";
import Address from "@/models/Address";
import Image from "@/models/Image";
import BeCuponUtils from "@/utils/Utils";
import Order from "@/models/Order";
import CouponUses from "@/models/CouponUses";
import Employment from "@/models/Employment";
import Manager from "@/models/Manager";
import Commercial from "@/models/Commercial";
import Feedback from "@/models/Feedback";
import Maintenance from "@/models/Maintenance";
import CurrentVersion from "@/models/CurrentVersion";
import ClientType from "@/models/ClientType";
import Deal from "@/models/Deal";
import SubCategoryDesc from "@/models/SubCategoryDesc";
import CouponOff from "@/models/CouponOff";
import Service from "@/models/Service";
import NotificationBody from "@/models/NotificationBody";
import NotificationSent from "@/models/NotificationSent";
import GlobalConfiguration from "@/models/GlobalConfiguration";
import Meta from "@/models/Meta";
import MetaGroup from "@/models/MetaGroup";
import MetaSeller from "@/models/MetaSeller";
import Seller from "@/models/Seller";
import API from "../api.js";
import Promotion from "@/models/Promotion";
import Raffles from "@/models/Raffles";
import LoyaltyCampaing from "@/models/LoyaltyCampaing";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "#790058", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "white",
    couponNoUseList: [],
    couponList: [],
    promotionList: [],
    promotion: {},
    loyaltyCampaingList: [],
    loyaltyCampaingUsersList: [],
    loyaltyCampaing: {},
    coupon: {},
    couponWelcomeList: [],
    couponWelcome: {},
    couponReferenceList: [],
    couponReference: {},
    couponRefererList: [],
    couponReferer: {},
    couponWelcomeUserList: [],
    couponWelcomeUser: {},
    couponReferenceUserList: [],
    couponReferenceUser: {},
    couponRefererUserList: [],
    couponRefererUser: {},
    ok: false,
    rafflesList: [],
    couponsList: [],
    coupons: {},
    raffles: {},
    companyList: [],
    company: {},
    branchOffice: {},
    branchOfficeList: [],
    category: {},
    categoryList: [],
    userId: localStorage.getItem("userId"),
    currentUser: null,
    user: {},
    userList: [],
    group: {},
    groupList: [],
    permissionList: [],
    payment: {},
    paymentList: [],
    paymentFilterList: [],
    order: {},
    orderList: [],
    couponUse: {},
    couponUseList: [],
    getUses: -1,
    country: {},
    countryList: [],
    region: {},
    regionList: [],
    city: {},
    cityList: [],
    cityToCoupons: [],
    address: {},
    addressList: [],
    addressId: -1,
    imageId: -1,
    imagesIds: -1,
    imageIdList: [],
    employment: {},
    employmentList: [],
    manager: {},
    managerList: [],
    commercial: {},
    commercialList: [],
    feedback: {},
    feedbackList: [],
    feedbackStates: ["Pendiente", "En revisión", "Resuelto"],
    maintenance: {},
    maintenanceList: [],
    currentVersion: {},
    currentVersionList: [],
    appNames: [
      "becupon-android",
      "becupon-ios",
      "sucursal-becupon-android",
      "sucursal-becupon-ios",
    ],
    hasPermissionToView: false,
    hasPermissionToCreate: false,
    hasPermissionToUpdate: false,
    hasPermissionToDelete: false,
    isEmployment: -1,
    isManager: -1,
    token: localStorage.getItem("token"),
    errorMessage: "",
    clientType: {},
    clientTypeList: [],
    deal: {},
    dealList: [],
    subCategoryDesc: {},
    subCategoryDescList: [],
    couponOff: {},
    couponOffList: [],
    service: {},
    serviceList: [],
    notificationBody: {},
    notificationBodyList: [],
    notificationSent: {},
    notificationSentList: [],
    couponsRegionList: [],
    couponsCityList: [],
    globalConfiguration: {},
    globalConfigurationList: [],
    meta: {},
    metaList: [],
    metaGroup: {},
    metaGroupList: [],
    metaSeller: {},
    metaSellerList: [],
    seller: {},
    sellerList: [],
  },
  mutations: {
    // COMMON
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_OK(state, payload) {
      state.ok = payload;
    },
    HAS_PERMISSION_TO_VIEW(state, payload) {
      state.hasPermissionToView = BeCuponUtils.hasPermissionToView(
        state.currentUser,
        payload.groups
      );
    },
    HAS_PERMISSION_TO_CREATE(state, payload) {
      state.hasPermissionToCreate = BeCuponUtils.hasPermissionToCreate(
        state.currentUser,
        payload.groups
      );
    },
    HAS_PERMISSION_TO_UPDATE(state, payload) {
      state.hasPermissionToUpdate = BeCuponUtils.hasPermissionToUpdate(
        state.currentUser,
        payload.groups
      );
    },
    HAS_PERMISSION_TO_DELETE(state, payload) {
      state.hasPermissionToDelete = BeCuponUtils.hasPermissionToDelete(
        state.currentUser,
        payload.groups
      );
    },
    HAS_PERMISSION_TO_VIEW_DASHBOARD(state) {
      state.hasPermissionToView =
        state.currentUser !== null && state.currentUser !== undefined;
    },
    IS_EMPLOYMENT(state) {
      state.isEmployment = BeCuponUtils.isEmployment(state.currentUser);
    },
    IS_MANAGER(state) {
      state.isManager = BeCuponUtils.isManager(state.currentUser);
    },
    SET_ERROR_MESSAGE(state, payload) {
      state.errorMessage = payload;
    },
    // END COMMON

    // AUTH
    async LOGIN(state, payload) {
      state.tokenAuth = await Auth.login(
        payload.axios,
        payload.username,
        payload.password,
        payload.store
      );
      // console.log('El tokenAuth Tiene Esto...!!!', state.tokenAuth);
      state.token = state.tokenAuth.token;
      if (state.token !== null) {
        localStorage.setItem("token", state.token);
        localStorage.setItem("userId", state.tokenAuth.user.pk);
        localStorage.setItem("refreshToken", state.tokenAuth.refreshToken);
        state.errorMessage = "";
      } else {
        if (
          localStorage.getItem("token") === null ||
          localStorage.getItem("token") === "null"
        ) {
          localStorage.setItem("token", "null-new");
          state.token = "null-new";
        } else {
          localStorage.setItem("token", null);
          state.token = null;
        }
      }
    },
    async LOGOUT(state, payload) {
      state.token = null;
      state.currentUser = null;
      state.errorMessage = "";
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("refreshToken");
      await Auth.logout(payload.axios, payload.refreshToken, payload.store);
      },
    async ME(state, payload) {
      state.currentUser = await Auth.me(payload.axios);
      state.userId = Number(state.currentUser.id);
      localStorage.setItem("userId", state.userId);
      localStorage.setItem("currentUser", JSON.stringify(state.currentUser));
    },
    // END AUTH

    // USER
    async CURRENT_USER(state, payload) {
      if (state.userId > 0) {
        state.currentUser = await User.retrieve(
          payload.axios,
          localStorage.getItem("userId")
        );
        localStorage.setItem("currentUser", JSON.stringify(state.currentUser));
      }
    },
    async USER(state, payload) {
      state.user = await User.retrieve(payload.axios, payload.id);
    },
    async USER_LIST(state, payload) {
      state.userList = await User.all(
        payload.axios,
        payload.active,
        payload.affiliate
      );
    },
    async USER_FILTER(state, payload) {
      state.userList = await User.filter(payload.axios, payload.active);
    },
    async CREATE_USER(state, payload) {
      state.ok = await User.create(
        payload.axios,
        payload.username,
        payload.password,
        payload.email,
        payload.firstName,
        payload.lastName,
        payload.isStaff,
        payload.isActive,
        payload.groups,
        payload.phone,
        payload.birthday,
        payload.image,
        payload.country,
        payload.region,
        payload.city
      );
    },
    async EDIT_USER(state, payload) {
      state.ok = await User.edit(
        payload.axios,
        payload.id,
        payload.username,
        payload.password,
        payload.email,
        payload.firstName,
        payload.lastName,
        payload.isStaff,
        payload.isActive,
        payload.groups,
        payload.phone,
        payload.birthday,
        payload.image,
        payload.country,
        payload.region,
        payload.city
      );
    },
    async EDIT_USER_DELETE(state, payload) {
      state.ok = await User.edit_noactive(
        payload.axios,
        payload.id,
        payload.active
      );
    },
    async ACTIVE_USER(state, payload) {
      state.ok = await User.edit(payload.axios, payload.id, payload.username);
    },
    async DELETE_USER(state, payload) {
      state.ok = await User.delete(payload.axios, payload.id);
    },
    async USER_AVAILABLE(state, payload) {
      state.userList = await User.userAvailableEmployment(
        payload.axios,
        payload.affiliate
      );
    },
    // END USER

    // GROUP
    async GROUP(state, payload) {
      state.group = await Group.retrieve(payload.axios, payload.id);
    },
    async GROUP_LIST(state, axios) {
      state.groupList = await Group.all(axios);
    },
    async GROUP_FILTER(state, payload) {
      state.groupList = await Group.filter(payload.axios, payload.active);
    },
    async CREATE_GROUP(state, payload) {
      state.ok = await Group.create(
        payload.axios,
        payload.name,
        payload.permissions
      );
    },
    async EDIT_GROUP(state, payload) {
      state.ok = await Group.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.permissions
      );
    },
    async DELETE_GROUP(state, payload) {
      state.ok = await Group.delete(payload.axios, payload.id);
    },
    // END Group

    // PERMISSION
    async PERMISSION_LIST(state, axios) {
      state.permissionList = await Permission.all(axios);
    },
    // END PERMISSION

    // COUPON
    async COUPON(state, payload) {
      state.coupon = await Coupon.retrieve(payload.axios, payload.id);
    },
    async COUPON_NO_USE_LIST(state, payload) {
      state.couponList = await Coupon.couponNoUses(
        payload.axios,
        payload.company,
        payload.branchOffice
      );
      state.couponNoUseList = state.couponList;
    },
    // async COUPON_NO_USED_LIST(state, payload) {
    //   state.couponList = await Coupon.couponNoUsedList(payload.axios)
    //   state.couponNoUsedList = state.couponList
    // },
    async COUPON_LIST(state, payload) {
      state.couponList = await Coupon.all(payload);
    },
    async COUPON_COUPONS_LIST(state, payload) {
      state.couponList = await Coupon.allOfCoupons(
        payload.axios,
        payload.active,
        payload.coupons
      );
    },
    async COUPON_BRANCH_OFFICE_LIST(state, payload) {
      state.couponList = await Coupon.allOfBranchOffice(
        payload.axios,
        payload.active,
        payload.branchOffice
      );
    },
    async COUPON_COMPANY_LIST(state, payload) {
      state.couponList = await Coupon.allOfCompany(
        payload.axios,
        payload.active,
        payload.company
      );
    },
    async COUPON_FILTER(state, payload) {
      state.couponList = await Coupon.filter(
        payload.axios,
        payload.active,
        payload.company
      );
    },
    async CREATE_COUPON(state, payload) {
      state.ok = await Coupon.create(
        payload.axios,
        payload.title,
        payload.subTitle,
        payload.description,
        payload.smallDescription,
        payload.initialDate,
        payload.expirationDate,
        payload.dailyUses,
        payload.totalUses,
        payload.maxPerson,
        payload.valuedAt,
        payload.coupons,
        payload.images,
        payload.branchOffices,
        payload.hideAuto,
        payload.datetimeHideAutoStart,
        payload.datetimeHideAutoOff,
        payload.deal,
        payload.subCategory,
        payload.clientType
      );
    },
    async EDIT_COUPON(state, payload) {
      state.ok = await Coupon.edit(
        payload.axios,
        payload.id,
        payload.title,
        payload.subTitle,
        payload.description,
        payload.smallDescription,
        payload.initialDate,
        payload.expirationDate,
        payload.dailyUses,
        payload.totalUses,
        payload.maxPerson,
        payload.valuedAt,
        payload.coupons,
        payload.images,
        payload.branchOffices,
        payload.hideAuto,
        payload.datetimeHideAutoStart,
        payload.datetimeHideAutoOff,
        payload.deal,
        payload.subCategory,
        payload.clientType,
        payload.showApp
      );
    },
    async DELETE_COUPON(state, payload) {
      if (payload.id > 0) {
        state.ok = await Coupon.delete(payload.axios, payload.id);
      } else {
        state.ok = null;
      }
    },
    // END COUPON

    //COUPON WELCOME
    async COUPON_WELCOME(state, payload) {
      state.couponWelcome = await CouponWelcome.retrieve(
        payload.axios,
        payload.id
      );
    },
    async COUPON_WELCOME_LIST(state, axios) {
      state.couponWelcomeList = await CouponWelcome.all(axios);
    },
    async COUPON_WELCOME_DELETE(state, payload) {
      state.ok = await CouponWelcome.delete(payload.axios, payload.id);
    },
    //END COUPON WELCOME

    //COUPON REFERENCE
    async COUPON_REFERENCE(state, payload) {
      state.couponReference = await CouponReference.retrieve(
        payload.axios,
        payload.id
      );
    },
    async COUPON_REFERENCE_LIST(state, axios) {
      state.couponReferenceList = await CouponReference.all(axios);
    },
    async COUPON_REFERENCE_DELETE(state, payload) {
      state.ok = await CouponReference.delete(payload.axios, payload.id);
    },
    //END COUPON REFERENCE

    //COUPON REFERER
    async COUPON_REFERER(state, payload) {
      state.couponReferer = await CouponReferer.retrieve(
        payload.axios,
        payload.id
      );
    },
    async COUPON_REFERER_LIST(state, axios) {
      state.couponRefererList = await CouponReferer.all(axios);
    },
    async COUPON_REFERER_DELETE(state, payload) {
      state.ok = await CouponReferer.delete(payload.axios, payload.id);
    },
    //END COUPON REFERER

    //COUPON WELCOME USER
    async COUPON_WELCOME_USER(state, payload) {
      state.couponWelcomeUser = await CouponWelcomeUser.retrieve(
        payload.axios,
        payload.id
      );
    },
    async COUPON_WELCOME_USER_LIST(state, axios) {
      state.couponWelcomeUserList = await CouponWelcomeUser.all(axios);
    },
    //END COUPON WELCOME USER

    //COUPON REFERENCE USER
    async COUPON_REFERENCE_USER(state, payload) {
      state.couponReferenceUser = await CouponReferenceUser.retrieve(
        payload.axios,
        payload.id
      );
    },
    async COUPON_REFERENCE_USER_LIST(state, axios) {
      state.couponReferenceUserList = await CouponReferenceUser.all(axios);
    },
    //END COUPON REFERENCE USER

    //COUPON REFERER USER
    async COUPON_REFERER_USER(state, payload) {
      state.couponRefererUser = await CouponRefererUser.retrieve(
        payload.axios,
        payload.id
      );
    },
    async COUPON_REFERER_USER_LIST(state, axios) {
      state.couponRefererUserList = await CouponRefererUser.all(axios);
    },
    //END COUPON REFERER USER
    // RAFFLES
    async RAFFLES_LIST(state, payload) {
      state.rafflesList = await Raffles.all(payload);
    },
    async RAFFLES(state, payload) {
      state.raffles = await Raffles.retrieve(payload.axios, payload.id);
    },
    // END RAFFLES
    // COUPONS
    async COUPONS(state, payload) {
      state.coupons = await Coupons.retrieve(payload.axios, payload.id);
    },
    async COUPONS_LIST_TO_CREATE_COUPON(state, axios) {
      state.couponsList = await Coupons.allToCreateCoupon(axios);
    },
    async COUPONS_LIST(state, payload) {
      state.couponsList = await Coupons.all(payload);
    },
    async COUPONS_BRANCH_OFFICE_LIST(state, payload) {
      state.couponsList = await Coupons.allOfBranchOffice(
        payload.axios,
        payload.active,
        payload.branchOffice
      );
    },
    async COUPONS_COMPANY_LIST(state, payload) {
      state.couponsList = await Coupons.allOfCompany(
        payload.axios,
        payload.active,
        payload.company
      );
    },
    async COUPONS_FILTER(state, payload) {
      state.couponsList = await Coupons.filter(
        payload.axios,
        payload.active,
        payload.category
      );
    },
    async EDIT_COUPONS(state, payload) {
      state.ok = await Coupons.edit(payload);
      /*state.ok = await Coupons.edit(payload.axios, payload.id, payload.title, payload.subTitle, payload.description, payload.initialDate,
        payload.expirationDate, payload.price, payload.value, payload.saveValue, payload.discount,
        payload.distinguished, payload.hot, payload.newV, payload.categories, payload.region, payload.images, payload.maximumSales, payload.alwaysShow, payload.hideAuto,
        payload.datetimeHideAutoStart, payload.datetimeHideAutoOff, payload.lat, payload.lng, payload.clientTypeId, payload.cities, payload.companies
        )*/
    },
    async CREATE_COUPONS(state, payload) {
      state.ok = await Coupons.create(
        payload.axios,
        payload.title,
        payload.subTitle,
        payload.description,
        payload.initialDate,
        payload.expirationDate,
        payload.price,
        payload.value,
        payload.saveValue,
        payload.discount,
        payload.distinguished,
        payload.hot,
        payload.newV,
        payload.categories,
        payload.images,
        payload.maximumSales,
        payload.alwaysShow,
        payload.hideAuto,
        payload.datetimeHideAutoStart,
        payload.datetimeHideAutoOff,
        payload.lat,
        payload.lng,
        payload.clientTypeId,
        payload.cities,
        payload.companies,
        payload.free
      );
    },
    async DELETE_COUPONS(state, payload) {
      if (payload.id > 0) {
        state.ok = await Coupons.delete(payload.axios, payload.id);
      } else {
        state.ok = null;
      }
    },
    // END COUPONS
    // RAFFLES
    async DELETE_RAFLES(state, payload) {
      if (payload.id > 0) {
        state.ok = await Raffles.delete(payload.axios, payload.id);
      } else {
        state.ok = null;
      }
    },
    // END RAFFLES
    // COMPANY
    async COMPANY(state, payload) {
      state.company = await Company.retrieve(payload.axios, payload.id);
    },
    async COMPANY_LIST_TO_CREATE_COUPON(state, axios) {
      state.companyList = await Company.allToCreateCoupon(axios);
    },
    async COMPANY_LIST(state, payload) {
      state.companyList = await Company.all(payload);
    },
    async COMPANY_FILTER(state, payload) {
      state.companyList = await Company.filter(payload);
    },
    async CREATE_COMPANY(state, payload) {
      state.ok = await Company.create(
        payload.axios,
        payload.name,
        payload.description,
        payload.openTime,
        payload.closeTime,
        payload.phoneNumber,
        payload.images,
        payload.logo
      );
    },
    async EDIT_COMPANY(state, payload) {
      state.ok = await Company.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.description,
        payload.openTime,
        payload.closeTime,
        payload.phoneNumber,
        payload.images,
        payload.logo
      );
    },
    async DELETE_COMPANY(state, payload) {
      state.ok = await Company.delete(payload.axios, payload.id);
    },
    // END COMPANY

    //BRANCH OFFICE
    async BRANCH_OFFICE(state, payload) {
      state.branchOffice = await BranchOffice.retrieve(
        payload.axios,
        payload.id
      );
    },
    async BRANCH_OFFICE_LIST(state, payload) {
      state.branchOfficeList = await BranchOffice.all(payload);
    },
    async BRANCH_OFFICE_OF_COMPANY_LIST(state, payload) {
      state.branchOfficeList = await BranchOffice.allOfCompany(
        payload.axios,
        payload.active,
        payload.company
      );
    },
    async BRANCH_OFFICE_FILTER(state, payload) {
      state.branchOfficeList = await BranchOffice.filter(
        payload.axios,
        payload.active,
        payload.company
      );
    },
    async CREATE_BRANCH_OFFICE(state, payload) {
      state.ok = await BranchOffice.create(
        payload.axios,
        payload.name,
        payload.description,
        payload.openTime,
        payload.closeTime,
        payload.phoneNumber,
        payload.company,
        payload.address,
        payload.locality,
        payload.state,
        payload.country,
        payload.latitude,
        payload.longitude,
        payload.polygon,
        payload.affiliate
      );
    },
    async EDIT_BRANCH_OFFICE(state, payload) {
      state.ok = await BranchOffice.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.description,
        payload.openTime,
        payload.closeTime,
        payload.phoneNumber,
        payload.company,
        payload.address,
        payload.locality,
        payload.state,
        payload.country,
        payload.latitude,
        payload.longitude,
        payload.polygon,
        payload.affiliate,
      );
    },
    async DELETE_BRANCH_OFFICE(state, payload) {
      state.ok = await BranchOffice.delete(payload.axios, payload.id);
    },
    //END BRANCH OFFICE

    //CATEGORY
    async CATEGORY(state, payload) {
      state.category = await Category.retrieve(payload.axios, payload.id);
    },
    async CATEGORY_LIST(state, axios) {
      state.categoryList = await Category.all(axios);
    },
    async CREATE_CATEGORY(state, payload) {
      state.ok = await Category.create(
        payload.axios,
        payload.name,
        payload.parent,
        payload.image
      );
    },
    async EDIT_CATEGORY(state, payload) {
      state.ok = await Category.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.parent,
        payload.image
      );
    },
    async DELETE_CATEGORY(state, payload) {
      state.ok = await Category.delete(payload.axios, payload.id);
    },
    //END CATEGORY

    // PAYMENTS
    async PAYMENT(state, payload) {
      state.payment = await Payment.retrieve(payload.axios, payload.id);
    },
    async PAYMENT_LIST(state, axios) {
      state.paymentList = await Payment.all(axios);
    },
    async PAYMENT_FILTER(state, payload) {
      state.paymentFilterList = await Payment.filter(
        payload.axios,
        payload.init,
        payload.last
      );
    },
    async PAYMENT_BRANCH_OFFICE_LIST(state, payload) {
      state.paymentList = await Payment.allOfBranchOffice(
        payload.axios,
        payload.branchOffice,
        payload.init,
        payload.last
      );
    },
    async PAYMENT_COMPANY_LIST(state, payload) {
      state.paymentList = await Payment.allOfCompany(
        payload.axios,
        payload.company,
        payload.init,
        payload.last
      );
    },
    // END PAYMENTS

    // ORDER
    async ORDER(state, payload) {
      state.order = await Order.retrieve(payload.axios, payload.id);
    },
    async ORDER_LIST(state, axios) {
      state.orderList = await Order.all(axios);
    },
    async ORDER_FILTER(state, payload) {
      state.orderList = await Order.filter(
        payload.axios,
        payload.init,
        payload.last
      );
    },
    async ORDER_BRANCH_OFFICE_LIST(state, payload) {
      state.orderList = await Order.allOfBranchOffice(
        payload.axios,
        payload.branchOffice,
        payload.init,
        payload.last
      );
    },
    async ORDER_COMPANY_LIST(state, payload) {
      state.orderList = await Order.allOfCompany(
        payload.axios,
        payload.company,
        payload.init,
        payload.last
      );
    },
    // END ORDER
    // PROMOTION
    async PROMOTION_LIST(state, payload) {
      state.promotionList = await Promotion.all(payload);
    },
    async PROMOTION(state, payload) {
      state.promotion = await Promotion.retrieve(payload.axios, payload.id);
    },
    async DELETE_PROMOTION(state, payload) {
      if (payload.id > 0) {
        state.ok = await Promotion.delete(payload.axios, payload.id);
      } else {
        state.ok = null;
      }
    },
    // END PROMOTION
    // LOYALTY CAMPAING
    async LOYALTY_CAMPAING_LIST(state, payload) {
      state.loyaltyCampaingList = await LoyaltyCampaing.all(payload);
    },
    async LOYALTY_CAMPAING(state, payload) {
      state.loyaltyCampaing = await LoyaltyCampaing.retrieve(payload.axios, payload.id);
      state.loyaltyCampaingUsersList = state.loyaltyCampaing.compressed.users;
    },
    async DELETE_LOYALTY_CAMPAING(state, payload) {
      if (payload.id > 0) {
        state.ok = await LoyaltyCampaing.delete(payload.axios, payload.id);
      } else {
        state.ok = null;
      }
    },
    // END LOYALTY CAMPAING
    // COUPON USE
    async COUPON_USE(state, payload) {
      state.couponUse = await CouponUses.retrieve(payload.axios, payload.id);
    },
    async COUPON_USE_LIST(state, axios) {
      state.couponUseList = await CouponUses.all(axios);
    },
    async COUPON_USE_FILTER(state, payload) {
      state.couponUseList = await CouponUses.filter(
        payload.axios,
        payload.init,
        payload.last
      );
    },
    async COUPON_USE_BRANCH_OFFICE_LIST(state, payload) {
      state.couponUseList = await CouponUses.allOfBranchOffice(
        payload.axios,
        payload.branchOffice,
        payload.init,
        payload.last
      );
    },
    async COUPON_USE_COMPANY_LIST(state, payload) {
      state.couponUseList = await CouponUses.allOfCompany(
        payload.axios,
        payload.company,
        payload.init,
        payload.last
      );
    },
    async GET_USES(state, payload) {
      state.getUses = await CouponUses.getUses(
        payload.axios,
        payload.couponsInstance,
        payload.coupon,
        payload.user
      );
    },
    // END COUPON USE

    //COUNTRY
    async COUNTRY(state, payload) {
      state.country = await Country.retrieve(payload.axios, payload.id);
    },
    async COUNTRY_LIST(state, axios) {
      state.countryList = await Country.all(axios);
    },
    async CREATE_COUNTRY(state, payload) {
      state.ok = await Country.create(payload.axios, payload.name);
    },
    async EDIT_COUNTRY(state, payload) {
      state.ok = await Country.edit(payload.axios, payload.id, payload.name);
    },
    async DELETE_COUNTRY(state, payload) {
      state.ok = await Country.delete(payload.axios, payload.id);
    },
    //END COUNTRY

    // REGION
    async REGION(state, payload) {
      state.region = await Region.retrieve(payload.axios, payload.id);
    },
    async REGION_LIST(state, axios) {
      state.regionList = await Region.all(axios);
    },
    async REGION_FILTER(state, payload) {
      state.regionList = await Region.filter(payload.axios, payload.country);
    },
    async CREATE_REGION(state, payload) {
      state.ok = await Region.create(
        payload.axios,
        payload.name,
        payload.country
      );
    },
    async EDIT_REGION(state, payload) {
      state.ok = await Region.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.country
      );
    },
    async DELETE_REGION(state, payload) {
      state.ok = await Region.delete(payload.axios, payload.id);
    },
    //END REGION

    // CITY
    async CITY(state, payload) {
      state.city = await City.retrieve(payload.axios, payload.id);
    },
    async CITY_LIST(state, axios) {
      state.cityList = await City.all(axios);
    },
    async CITY_FILTER(state, payload) {
      state.cityList = await City.filter(payload.axios, payload.region);
    },
    async CREATE_CITY(state, payload) {
      state.ok = await City.create(
        payload.axios,
        payload.name,
        payload.latitude,
        payload.longitude,
        payload.region
      );
    },
    async EDIT_CITY(state, payload) {
      state.ok = await City.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.latitude,
        payload.longitude,
        payload.country
      );
    },
    async DELETE_CITY(state, payload) {
      state.ok = await City.delete(payload.axios, payload.id);
    },
    //END CITY

    // ADDRESS
    async ADDRESS(state, payload) {
      state.address = await Address.retrieve(payload.axios, payload.id);
    },
    async ADDRESS_LIST(state, axios) {
      state.addressList = await Address.all(axios);
    },
    async ADDRESS_FILTER(state, payload) {
      state.addressList = await Address.filter(payload.axios, payload.city);
    },
    async CREATE_ADDRESS(state, payload) {
      let resp = await Address.create(
        payload.axios,
        payload.street,
        payload.unit,
        payload.houseNumber,
        payload.postCode,
        payload.latitude,
        payload.longitude,
        payload.city
      );
      if (!resp) {
        state.ok = resp;
      } else {
        state.ok = true;
        state.addressId = resp;
      }
    },
    async EDIT_ADDRESS(state, payload) {
      let resp = await Address.edit(
        payload.axios,
        payload.id,
        payload.street,
        payload.unit,
        payload.houseNumber,
        payload.postCode,
        payload.latitude,
        payload.longitude,
        payload.city
      );
      if (!resp) {
        state.ok = resp;
      } else {
        state.ok = true;
        state.addressId = resp;
      }
    },
    async DELETE_ADDRESS(state, payload) {
      state.ok = await Address.delete(payload.axios, payload.id);
    },
    //END ADDRESS

    //IMAGES
    async CREATE_IMAGES(state, payload) {
      let resp = await Image.create(payload.axios, payload.images);

      if (resp.length === 0) {
        state.ok = false;
        state.imagesIds = -1;
      } else {
        state.ok = true;
        state.imagesIds = resp;
      }
    },
    async CREATE_IMAGE(state, payload) {
      let resp = await Image.create(payload.axios, payload.image);

      if (resp.length === 0) {
        state.ok = false;
        state.imageId = -1;
      } else {
        state.ok = true;
        state.imageId = parseInt(resp[0]);
      }
    },
    async DELETE_IMAGES(state, payload) {
      if (payload.imagesIds > 0) {
        await Image.delete(payload.axios, payload.imagesIds);
      }
    },
    RESET_IMAGES_ID(state) {
      state.imageId = -1;
      state.imagesIds = -1;
    },
    RESET_COUPON_OBJ(state) {
      state.coupon = {};
    },

    //END IMAGES

    // EMPLOYMENT
    async EMPLOYMENT(state, payload) {
      state.employment = await Employment.retrieve(payload.axios, payload.id);
    },
    async EMPLOYMENT_LIST(state, payload) {
      state.employmentList = await Employment.all(payload);
    },
    async EMPLOYMENT_COMPANY_LIST(state, payload) {
      state.employmentList = await Employment.allOfCompany(
        payload.axios,
        payload.company
      );
    },
    async EMPLOYMENT_FILTER(state, payload) {
      state.employmentList = await Employment.filter(
        payload.axios,
        payload.branchOffice
      );
    },
    async CREATE_EMPLOYMENT(state, payload) {
      state.ok = await Employment.create(
        payload.axios,
        payload.user,
        payload.branchOffice
      );
    },
    async EDIT_EMPLOYMENT(state, payload) {
      state.ok = await Employment.edit(
        payload.axios,
        payload.id,
        payload.user,
        payload.branchOffice
      );
    },
    async DELETE_EMPLOYMENT(state, payload) {
      state.ok = await Employment.delete(payload.axios, payload.id);
    },
    // END EMPLOYMENT

    // MANAGER
    async MANAGER(state, payload) {
      state.manager = await Manager.retrieve(payload.axios, payload.id);
    },
    async MANAGER_LIST(state, payload) {
      state.managerList = await Manager.all(payload);
    },
    // async MANAGER_FILTER(state, payload) {
    //   state.managerList = await Manager.filter(payload.axios, payload.branchOffice)
    // },
    async CREATE_MANAGER(state, payload) {
      state.ok = await Manager.create(
        payload.axios,
        payload.user,
        payload.company,
        payload.sendNotif
      );
    },
    async EDIT_MANAGER(state, payload) {
      state.ok = await Manager.edit(
        payload.axios,
        payload.id,
        payload.user,
        payload.company,
        payload.sendNotif
      );
    },
    async DELETE_MANAGER(state, payload) {
      state.ok = await Manager.delete(payload.axios, payload.id);
    },
    // END MANAGER

    // COMMERCIAL
    async COMMERCIAL(state, payload) {
      state.commercial = await Commercial.retrieve(payload.axios, payload.id);
    },
    async COMMERCIAL_LIST(state, axios) {
      state.commercialList = await Commercial.all(axios);
    },
    async COMMERCIAL_COMPANY_LIST(state, payload) {
      state.commercialList = await Commercial.allOfCompany(
        payload.axios,
        payload.company
      );
    },
    async COMMERCIAL_FILTER(state, payload) {
      state.commercialList = await Commercial.filter(
        payload.axios,
        payload.active
      );
    },
    async CREATE_COMMERCIAL(state, payload) {
      state.ok = await Commercial.create(
        payload.axios,
        payload.name,
        payload.description,
        payload.url,
        payload.image,
        payload.company,
        payload.coupons,
        payload.active
      );
    },
    async EDIT_COMMERCIAL(state, payload) {
      state.ok = await Commercial.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.description,
        payload.url,
        payload.image,
        payload.company,
        payload.coupons,
        payload.active
      );
    },
    async DELETE_COMMERCIAL(state, payload) {
      state.ok = await Commercial.delete(payload.axios, payload.id);
    },
    // END COMMERCIAL

    // FEEDBACK
    async FEEDBACK(state, payload) {
      state.feedback = await Feedback.retrieve(payload.axios, payload.id);
    },
    async FEEDBACK_LIST(state, axios) {
      state.feedbackList = await Feedback.all(axios);
    },
    async FEEDBACK_FILTER(state, payload) {
      state.feedbackList = await Feedback.filter(
        payload.axios,
        payload.init,
        payload.last
      );
    },
    async EDIT_FEEDBACK(state, payload) {
      state.ok = await Feedback.edit(payload.axios, payload.id, payload.state);
    },
    // END FEEDBACK

    // MAINTENANCE
    async MAINTENANCE(state, payload) {
      state.maintenance = await Maintenance.retrieve(payload.axios, payload.id);
    },
    async MAINTENANCE_LIST(state, axios) {
      state.maintenanceList = await Maintenance.all(axios);
    },
    async CREATE_MAINTENANCE(state, payload) {
      state.ok = await Maintenance.create(
        payload.axios,
        payload.app,
        payload.dateTimeEnd
      );
    },
    async EDIT_MAINTENANCE(state, payload) {
      state.ok = await Maintenance.edit(
        payload.axios,
        payload.id,
        payload.app,
        payload.dateTimeEnd
      );
    },
    async DELETE_MAINTENANCE(state, payload) {
      state.ok = await Maintenance.delete(payload.axios, payload.id);
    },
    // END MAINTENANCE

    // CURRENT VERSION
    async CURRENT_VERSION(state, payload) {
      state.currentVersion = await CurrentVersion.retrieve(
        payload.axios,
        payload.id
      );
    },
    async CURRENT_VERSION_LIST(state, axios) {
      state.currentVersionList = await CurrentVersion.all(axios);
    },
    async CREATE_CURRENT_VERSION(state, payload) {
      state.ok = await CurrentVersion.create(
        payload.axios,
        payload.app,
        payload.dateTimeEnd,
        payload.version,
        payload.changeLog
      );
    },
    async EDIT_CURRENT_VERSION(state, payload) {
      state.ok = await CurrentVersion.edit(
        payload.axios,
        payload.id,
        payload.app,
        payload.dateTimeEnd,
        payload.version,
        payload.changeLog
      );
    },
    async DELETE_CURRENT_VERSION(state, payload) {
      state.ok = await CurrentVersion.delete(payload.axios, payload.id);
    },
    // END CURRENT VERSION

    // CLIENTTYPE
    async CLIENTTYPE(state, payload) {
      state.clientType = await ClientType.retrieve(payload.axios, payload.id);
    },
    async CLIENTTYPE_LIST(state, axios) {
      state.clientTypeList = await ClientType.all(axios);
    },
    // async CLIENTTYPE_FILTER(state, payload) {
    //   state.clientTypeList = await ClientType.filter(payload.axios, payload.name)
    // },
    async CREATE_CLIENTTYPE(state, payload) {
      state.ok = await ClientType.create(
        payload.axios,
        payload.name,
        payload.desc,
        payload.logo
      );
    },
    async EDIT_CLIENTTYPE(state, payload) {
      state.ok = await ClientType.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.desc,
        payload.logo
      );
    },
    async DELETE_CLIENTTYPE(state, payload) {
      state.ok = await ClientType.delete(payload.axios, payload.id);
    },
    ADD_CITY_TO_COUPONS(state, cities) {
      state.cityToCoupons.push(...cities);
      // state.cityToCoupons =  [].concat(...state.cityToCoupons);
    },
    RESET_CITY_TO_COUPONS(state) {
      state.cityToCoupons = [];
    },
    UPDATE_COUPONS_REGION_LIST(state, regions) {
      state.couponsRegionList = regions;
    },
    UPDATE_COUPONS_CITY_LIST(state, cities) {
      state.couponsCityList = cities;
    },
    //END CLIENTTYPE

    // DEAL
    async DEAL(state, payload) {
      state.deal = await Deal.retrieve(payload.axios, payload.id);
    },
    async DEAL_LIST(state, axios, affiliate) {
      state.dealList = await Deal.all(axios, affiliate);
    },
    // async DEAL_FILTER(state, payload) {
    //   state.dealList = await Deal.filter(payload.axios, payload.name)
    // },
    async CREATE_DEAL(state, payload) {
      state.ok = await Deal.create(
        payload.axios,
        payload.name,
        payload.description,
        payload.dateStart,
        payload.dateOff,
        payload.totalCoupon,
        payload.totalCouponWelcome,
        payload.totalCouponReference,
        payload.totalCouponReferer,
        payload.totalCouponFree,
        payload.company,
        payload.services
      );
    },
    async EDIT_DEAL(state, payload) {
      state.ok = await Deal.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.description,
        payload.dateStart,
        payload.dateOff,
        payload.totalCoupon,
        payload.totalCouponWelcome,
        payload.totalCouponReference,
        payload.totalCouponReferer,
        payload.totalCouponFree,
        payload.company,
        payload.services
      );
    },
    async DELETE_DEAL(state, payload) {
      state.ok = await Deal.delete(payload.axios, payload.id);
    },
    //END DEAL

    // SubCategoryDesc
    async SUBCATEGORYDESC(state, payload) {
      state.subCategoryDesc = await SubCategoryDesc.retrieve(
        payload.axios,
        payload.id
      );
    },
    async SUBCATEGORYDESC_LIST(state, axios) {
      state.subCategoryDescList = await SubCategoryDesc.all(axios);
    },
    // async DEAL_FILTER(state, payload) {
    //   state.dealList = await Deal.filter(payload.axios, payload.name)
    // },
    async CREATE_SUBCATEGORYDESC(state, payload) {
      state.ok = await SubCategoryDesc.create(
        payload.axios,
        payload.name,
        payload.desc,
        payload.logo
      );
    },
    async EDIT_SUBCATEGORYDESC(state, payload) {
      state.ok = await SubCategoryDesc.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.desc,
        payload.logo
      );
    },
    async DELETE_SUBCATEGORYDESC(state, payload) {
      if (payload.id > 0) {
        state.ok = await SubCategoryDesc.delete(payload.axios, payload.id);
      } else {
        state.ok = null;
      }
    },
    //END SubCategoryDesc

    //CouponOff
    async COUPONOFF(state, payload) {
      state.couponOff = await CouponOff.retrieve(payload.axios, payload.id);
    },
    async COUPONOFF_LIST(state, axios) {
      state.couponOffList = await CouponOff.all(axios);
    },
    async CREATE_COUPONOFF(state, payload) {
      state.ok = await CouponOff.create(payload);
    },
    async EDIT_COUPONOFF(state, payload) {
      state.ok = await CouponOff.edit(payload);
    },
    async DELETE_COUPONOFF(state, payload) {
      state.ok = await CouponOff.delete(payload);
    },
    //END CouponOff

    // SERVICE
    async SERVICE(state, payload) {
      state.service = await Service.retrieve(payload.axios, payload.id);
    },
    async SERVICE_LIST(state, axios) {
      state.serviceList = await Service.all(axios);
    },
    // async DEAL_FILTER(state, payload) {
    //   state.dealList = await Deal.filter(payload.axios, payload.name)
    // },
    async CREATE_SERVICE(state, payload) {
      state.ok = await Service.create(
        payload.axios,
        payload.name,
        payload.description,
        payload.dateStart,
        payload.price,
        payload.active,
        payload.formAfiliate
      );
    },
    async EDIT_SERVICE(state, payload) {
      state.ok = await Service.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.description,
        payload.dateStart,
        payload.price,
        payload.active,
        payload.formAfiliate
      );
    },
    async DELETE_SERVICE(state, payload) {
      state.ok = await Service.delete(payload.axios, payload.id);
    },
    //END SERVICE

    // NotificationBody
    async NOTIFICATIONBODY(state, payload) {
      state.notificationBody = await NotificationBody.retrieve(
        payload.axios,
        payload.id
      );
    },
    async NOTIFICATIONBODY_LIST(state, axios) {
      state.notificationBodyList = await NotificationBody.all(axios);
    },
    // async CLIENTTYPE_FILTER(state, payload) {
    //   state.clientTypeList = await ClientType.filter(payload.axios, payload.name)
    // },
    async CREATE_NOTIFICATIONBODY(state, payload) {
      state.ok = await NotificationBody.create(
        payload.axios,
        payload.title,
        payload.text,
        payload.logo
      );
    },
    async EDIT_NOTIFICATIONBODY(state, payload) {
      state.ok = await NotificationBody.edit(
        payload.axios,
        payload.id,
        payload.title,
        payload.text,
        payload.logo
      );
    },
    async DELETE_NOTIFICATIONBODY(state, payload) {
      state.ok = await NotificationBody.delete(payload.axios, payload.id);
    },
    // End NotificationBody

    // NotificationSent
    async NOTIFICATIONSENT(state, payload) {
      state.notificationSent = await NotificationSent.retrieve(
        payload.axios,
        payload.id
      );
    },
    async NOTIFICATIONSENT_LIST(state, axios) {
      state.notificationSentList = await NotificationSent.all(axios);
    },
    async NOTIFICATIONSENT_FROMCLIENT_LIST(state, payload) {
      state.notificationSentList = await NotificationSent.fromClient(
        payload.axios,
        payload.client
      );
    },
    // async CLIENTTYPE_FILTER(state, payload) {
    //   state.clientTypeList = await ClientType.filter(payload.axios, payload.name)
    // },
    /*async CREATE_NOTIFICATIONBODY(state, payload) {
      state.ok = await NotificationBody.create(payload.axios, payload.title, payload.text, payload.logo)
    },
    async EDIT_NOTIFICATIONBODY(state, payload) {
      state.ok = await NotificationBody.edit(payload.axios, payload.id, payload.title, payload.text, payload.logo)
    },
    async DELETE_NOTIFICATIONBODY(state, payload) {
      state.ok = await NotificationBody.delete(payload.axios, payload.id)
  },*/
    // End NotificationSent

    async FILTER_IMAGE(state, payload) {
      state.imageId = await Image.filter(payload);
    },
    async IMAGE_ID_LIST(state, payload) {
      state.imageIdList = await Image.imageIdList(payload);
    },

    // GlobalConfiguration
    async GLOBAL_CONFIGURATION(state, payload) {
      state.globalConfiguration = await GlobalConfiguration.retrieve(
        payload.axios,
        payload.id
      );
    },
    async GLOBAL_CONFIGURATION_LIST(state, axios) {
      state.globalConfigurationList = await GlobalConfiguration.all(axios);
    },
    async CREATE_GLOBAL_CONFIGURATION(state, payload) {
      state.ok = await GlobalConfiguration.create(
        payload.axios,
        payload.name,
        payload.desc,
        payload.val
      );
    },
    async EDIT_GLOBAL_CONFIGURATION(state, payload) {
      state.ok = await GlobalConfiguration.edit(
        payload.axios,
        payload.id,
        payload.name,
        payload.desc,
        payload.val
      );
    },
    async DELETE_GLOBAL_CONFIGURATION(state, payload) {
      state.ok = await GlobalConfiguration.delete(payload.axios, payload.id);
    },
    // End GlobalConfiguration

    // Meta
    async META(state, payload) {
      state.meta = await Meta.retrieve(payload.axios, payload.id);
    },
    async META_LIST(state, axios) {
      state.metaList = await Meta.all(axios);
    },
    async DELETE_META(state, payload) {
      state.ok = await Meta.delete(payload.axios, payload.id);
    },

    // MetaGroup
    async METAGROUP(state, payload) {
      state.metaGroup = await MetaGroup.retrieve(payload.axios, payload.id);
    },
    async METAGROUP_LIST(state, axios) {
      state.metaGroupList = await MetaGroup.all(axios);
    },
    async DELETE_METAGROUP(state, payload) {
      state.ok = await MetaGroup.delete(payload.axios, payload.id);
    },

    // MetaSeller
    async METASELLER(state, payload) {
      state.metaSeller = await MetaSeller.retrieve(payload.axios, payload.id);
    },
    async METASELLER_LIST(state, axios) {
      state.metaSellerList = await MetaSeller.all(axios);
    },
    async DELETE_METASELLER(state, payload) {
      state.ok = await MetaSeller.delete(payload.axios, payload.id);
    },

    // Seller
    async SELLER(state, payload) {
      state.seller = await Seller.retrieve(payload.axios, payload.id);
    },
    async SELLER_LIST(state, axios) {
      state.sellerList = await Seller.all(axios);
    },
    async DELETE_SELLER(state, payload) {
      state.ok = await Seller.delete(payload.axios, payload.id);
    },
  },
  actions: {
    async execGraphQLQuery(context, { query }) {
      try {
        const resp = await API.post("graphql/", { query: query });
        return resp;
      } catch (error) {
        console.log(error);
        return error.response;
      }
    },
    async execGraphQLQueryParam(context, { query, variables }) {
      try {
        const resp = await API.post("graphql/", {
          query: query,
          variables: variables,
        });
        return resp;
      } catch (error) {
        console.log(error);
        return error.response;
      }
    },
    // AUTH
    actionsLogin({ commit }, payload) {
      commit("LOGIN", payload);
    },
    actionsLogout({ commit }, payload) {
      commit("LOGOUT", payload);
    },
    actionsMe({ commit }, payload) {
      commit("ME", payload);
    },
    // END AUTH

    // COMMON
    actionsSetOk({ commit }, payload) {
      commit("SET_OK", payload);
    },
    actionsSetErrorMessage({ commit }, payload) {
      commit("SET_ERROR_MESSAGE", payload);
    },
    // COMMON
    actionsHasPermissionToView({ commit }, payload) {
      commit("HAS_PERMISSION_TO_VIEW", payload);
    },
    actionsHasPermissionToCreate({ commit }, payload) {
      commit("HAS_PERMISSION_TO_CREATE", payload);
    },
    actionsHasPermissionToUpdate({ commit }, payload) {
      commit("HAS_PERMISSION_TO_UPDATE", payload);
    },
    actionsHasPermissionToDelete({ commit }, payload) {
      commit("HAS_PERMISSION_TO_DELETE", payload);
    },
    actionsHasPermissionToViewDashboard({ commit }) {
      commit("HAS_PERMISSION_TO_VIEW_DASHBOARD");
    },
    actionsIsEmployment({ commit }) {
      commit("IS_EMPLOYMENT");
    },
    actionsIsManager({ commit }) {
      commit("IS_MANAGER");
    },
    // END COMMON

    // USER
    actionsCurrentUser({ commit }, axios) {
      commit("CURRENT_USER", axios);
    },
    actionsUser({ commit }, axios) {
      commit("USER", axios);
    },
    actionsUserList({ commit }, payload) {
      commit("USER_LIST", payload);
    },
    actionsUserFilter({ commit }, payload) {
      commit("USER_FILTER", payload);
    },
    actionsCreateUser({ commit }, payload) {
      commit("CREATE_USER", payload);
    },
    actionsEditUser({ commit }, payload) {
      commit("EDIT_USER", payload);
    },
    actionsEditUserDeleted({ commit }, payload) {
      commit("EDIT_USER_DELETE", payload);
    },
    actionsActiveUser({ commit }, payload) {
      commit("ACTIVE_USER", payload);
    },
    actionsDeleteUser({ commit }, payload) {
      commit("DELETE_USER", payload);
    },
    actionsUserAvailable({ commit }, payload) {
      commit("USER_AVAILABLE", payload);
    },
    // END USER

    // GROUP
    actionsGroup({ commit }, axios) {
      commit("GROUP", axios);
    },
    actionsGroupList({ commit }, axios) {
      commit("GROUP_LIST", axios);
    },
    actionsGroupFilter({ commit }, payload) {
      commit("GROUP_FILTER", payload);
    },
    actionsCreateGroup({ commit }, payload) {
      commit("CREATE_GROUP", payload);
    },
    actionsEditGroup({ commit }, payload) {
      commit("EDIT_GROUP", payload);
    },
    actionsDeleteGroup({ commit }, payload) {
      commit("DELETE_GROUP", payload);
    },
    // END GROUP

    // PERMISSION
    actionsPermissionList({ commit }, axios) {
      commit("PERMISSION_LIST", axios);
    },
    // END PERMISSION

    // COUPON
    actionsCoupon({ commit }, axios) {
      // commit('RESET_COUPON_OBJ');
      commit("COUPON", axios);
    },
    actionsCouponNoUseList({ commit }, payload) {
      commit("COUPON_NO_USE_LIST", payload);
    },
    // actionsCouponNoUsedList({commit}, payload) {
    //   commit('COUPON_NO_USED_LIST', payload)
    // },
    // PROMOTION
    actionsPromotionList({ commit }, payload) {
      commit("PROMOTION_LIST", payload);
    },
    actionsPromotion({ commit }, axios) {
      commit("PROMOTION", axios);
    },
    // END PROMOTION
    // LOYALTY CAMPAING
    actionsLoyaltyCampaingList({ commit }, payload) {
      commit("LOYALTY_CAMPAING_LIST", payload);
    },
    actionsLoyaltyCampaing({ commit }, axios) {
      commit("LOYALTY_CAMPAING", axios);
    },
    // END LOYALTY CAMPAING
    actionsCouponList({ commit }, payload) {
      commit("COUPON_LIST", payload);
    },
    actionsCouponCouponsList({ commit }, payload) {
      commit("COUPON_COUPONS_LIST", payload);
    },
    actionsCouponBranchOfficeList({ commit }, payload) {
      commit("COUPON_BRANCH_OFFICE_LIST", payload);
    },
    actionsCouponCompanyList({ commit }, payload) {
      commit("COUPON_COMPANY_LIST", payload);
    },
    actionsCouponFilter({ commit }, payload) {
      commit("COUPON_FILTER", payload);
    },
    actionsCreateCoupon({ commit }, payload) {
      commit("CREATE_COUPON", payload);
    },
    actionsEditCoupon({ commit }, payload) {
      commit("EDIT_COUPON", payload);
    },
    actionsDeleteCoupon({ commit }, payload) {
      commit("DELETE_COUPON", payload);
    },
    // END COUPON
    // PROMOTION
    actionsDeletePromotion({ commit }, payload) {
      commit("DELETE_PROMOTION", payload);
    },
    actionsDeleteLoyaltyCampaing({ commit }, payload) {
      commit("DELETE_LOYALTY_CAMPAING", payload);
    },
    // COUPON WELCOME
    actionsCouponWelcome({ commit }, axios) {
      commit("COUPON_WELCOME", axios);
    },
    actionsCouponWelcomeList({ commit }, axios) {
      commit("COUPON_WELCOME_LIST", axios);
    },
    actionsDeleteCouponWelcome({ commit }, payload) {
      commit("COUPON_WELCOME_DELETE", payload);
    },
    // END COUPON WELCOME

    // COUPON REFERENCE
    actionsCouponReference({ commit }, axios) {
      commit("COUPON_REFERENCE", axios);
    },
    actionsCouponReferenceList({ commit }, axios) {
      commit("COUPON_REFERENCE_LIST", axios);
    },
    actionsDeleteCouponReference({ commit }, payload) {
      commit("COUPON_REFERENCE_DELETE", payload);
    },
    // END COUPON REFERENCE

    // COUPON REFERER
    actionsCouponReferer({ commit }, axios) {
      commit("COUPON_REFERER", axios);
    },
    actionsCouponRefererList({ commit }, axios) {
      commit("COUPON_REFERER_LIST", axios);
    },
    actionsDeleteCouponReferer({ commit }, payload) {
      commit("COUPON_REFERER_DELETE", payload);
    },
    // END COUPON REFERER

    // COUPON WELCOME USER
    actionsCouponWelcomeUser({ commit }, axios) {
      commit("COUPON_WELCOME_USER", axios);
    },
    actionsCouponWelcomeUserList({ commit }, axios) {
      commit("COUPON_WELCOME_USER_LIST", axios);
    },
    // END COUPON WELCOME USER

    // COUPON REFERENCE USER
    actionsCouponReferenceUser({ commit }, axios) {
      commit("COUPON_REFERENCE_USER", axios);
    },
    actionsCouponReferenceUserList({ commit }, axios) {
      commit("COUPON_REFERENCE_USER_LIST", axios);
    },
    // END COUPON REFERENCE USER

    // COUPON REFERER USER
    actionsCouponRefererUser({ commit }, axios) {
      commit("COUPON_REFERER_USER", axios);
    },
    actionsCouponRefererUserList({ commit }, axios) {
      commit("COUPON_REFERER_USER_LIST", axios);
    },
    // END COUPON REFERER USER
    // RAFFLES
    actionsRafflesList({ commit }, payload) {
      commit("RAFFLES_LIST", payload);
    },
    actionsRaffles({ commit }, axios) {
      // commit('RESET_COUPON_OBJ');
      commit("RAFFLES", axios);
    },
    // END RAFFLES
    // COUPONS
    actionsCoupons({ commit }, axios) {
      commit("COUPONS", axios);
    },
    actionsCouponsListToCreateCoupon({ commit }, axios) {
      commit("COUPONS_LIST_TO_CREATE_COUPON", axios);
    },
    actionsCouponsList({ commit }, payload) {
      commit("COUPONS_LIST", payload);
    },
    actionsCouponsBranchOfficeList({ commit }, payload) {
      commit("COUPONS_BRANCH_OFFICE_LIST", payload);
    },
    actionsCouponsCompanyList({ commit }, payload) {
      commit("COUPONS_COMPANY_LIST", payload);
    },
    actionsCouponsFilter({ commit }, payload) {
      commit("COUPONS_FILTER", payload);
    },
    actionsCreateCoupons({ commit }, payload) {
      commit("CREATE_COUPONS", payload);
    },
    actionsEditCoupons({ commit }, payload) {
      commit("EDIT_COUPONS", payload);
    },
    actionsDeleteCoupons({ commit }, payload) {
      commit("DELETE_COUPONS", payload);
    },
    // END COUPONS
    // RAFFLES
    actionsDeleteRaffles({ commit }, payload) {
      commit("DELETE_RAFLES", payload);
    },
    // END RAFFLES
    // COMPANY
    actionsCompany({ commit }, axios) {
      commit("COMPANY", axios);
    },
    actionsCompanyListToCreateCoupon({ commit }, axios) {
      commit("COMPANY_LIST_TO_CREATE_COUPON", axios);
    },
    actionsCompanyList({ commit }, payload) {
      commit("COMPANY_LIST", payload);
    },
    actionsCompanyFilter({ commit }, payload) {
      commit("COMPANY_FILTER", payload);
    },
    actionsCreateCompany({ commit }, payload) {
      commit("CREATE_COMPANY", payload);
    },
    actionsEditCompany({ commit }, payload) {
      commit("EDIT_COMPANY", payload);
    },
    actionsDeleteCompany({ commit }, payload) {
      commit("DELETE_COMPANY", payload);
    },
    // END COMPANY

    // BRANCH OFFICE
    actionsBranchOffice({ commit }, axios) {
      commit("BRANCH_OFFICE", axios);
    },
    // actionsBranchOfficeListToCreateCoupon({commit}, axios) {
    //   commit('COMPANY_LIST_TO_CREATE_COUPON', axios)
    // },
    actionsBranchOfficeList({ commit }, payload) {
      commit("BRANCH_OFFICE_LIST", payload);
    },
    actionsBranchOfficeOfCompanyList({ commit }, payload) {
      commit("BRANCH_OFFICE_OF_COMPANY_LIST", payload);
    },
    actionsBranchOfficeFilter({ commit }, payload) {
      commit("BRANCH_OFFICE_FILTER", payload);
    },
    actionsCreateBranchOffice({ commit }, payload) {
      commit("CREATE_BRANCH_OFFICE", payload);
    },
    actionsEditBranchOffice({ commit }, payload) {
      commit("EDIT_BRANCH_OFFICE", payload);
    },
    actionsDeleteBranchOffice({ commit }, payload) {
      commit("DELETE_BRANCH_OFFICE", payload);
    },
    // END BRANCH OFFICE

    // CATEGORY
    actionsCategory({ commit }, axios) {
      commit("CATEGORY", axios);
    },
    actionsCategoryList({ commit }, axios) {
      commit("CATEGORY_LIST", axios);
    },
    actionsCreateCategory({ commit }, payload) {
      commit("CREATE_CATEGORY", payload);
    },
    actionsEditCategory({ commit }, payload) {
      commit("EDIT_CATEGORY", payload);
    },
    actionsDeleteCategory({ commit }, payload) {
      commit("DELETE_CATEGORY", payload);
    },
    // END CATEGORY

    // PAYMENT
    actionsPayment({ commit }, axios) {
      commit("PAYMENT", axios);
    },
    actionsPaymentList({ commit }, axios) {
      commit("PAYMENT_LIST", axios);
    },
    actionsPaymentFilter({ commit }, payload) {
      commit("PAYMENT_FILTER", payload);
    },
    actionsPaymentBranchOfficeList({ commit }, payload) {
      commit("PAYMENT_BRANCH_OFFICE_LIST", payload);
    },
    actionsPaymentCompanyList({ commit }, payload) {
      commit("PAYMENT_COMPANY_LIST", payload);
    },
    // END PAYMENT

    // ORDER
    actionsOrder({ commit }, axios) {
      commit("ORDER", axios);
    },
    actionsOrderList({ commit }, axios) {
      commit("ORDER_LIST", axios);
    },
    actionsOrderFilter({ commit }, axios) {
      commit("ORDER_FILTER", axios);
    },
    actionsOrderBranchOfficeList({ commit }, payload) {
      commit("ORDER_BRANCH_OFFICE_LIST", payload);
    },
    actionsOrderCompanyList({ commit }, payload) {
      commit("ORDER_COMPANY_LIST", payload);
    },
    // END ORDER

    // COUPON USE
    actionsCouponUse({ commit }, axios) {
      commit("COUPON_USE", axios);
    },
    actionsCouponUseList({ commit }, axios) {
      commit("COUPON_USE_LIST", axios);
    },
    actionsCouponUseFilter({ commit }, payload) {
      commit("COUPON_USE_FILTER", payload);
    },
    actionsCouponUseBranchOfficeList({ commit }, payload) {
      commit("COUPON_USE_BRANCH_OFFICE_LIST", payload);
    },
    actionsCouponUseCompanyList({ commit }, payload) {
      commit("COUPON_USE_COMPANY_LIST", payload);
    },
    actionsGetUses({ commit }, axios) {
      commit("GET_USES", axios);
    },
    // END ORDER

    // EMPLOYMENT
    actionsEmployment({ commit }, axios) {
      commit("EMPLOYMENT", axios);
    },
    actionsEmploymentList({ commit }, payload) {
      commit("EMPLOYMENT_LIST", payload);
    },
    actionsEmploymentOfCompanyList({ commit }, axios) {
      commit("EMPLOYMENT_COMPANY_LIST", axios);
    },
    actionsEmploymentFilter({ commit }, payload) {
      commit("EMPLOYMENT_FILTER", payload);
    },
    actionsCreateEmployment({ commit }, payload) {
      commit("CREATE_EMPLOYMENT", payload);
    },
    actionsEditEmployment({ commit }, payload) {
      commit("EDIT_EMPLOYMENT", payload);
    },
    actionsDeleteEmployment({ commit }, payload) {
      commit("DELETE_EMPLOYMENT", payload);
    },
    // END EMPLOYMENT

    // COUNTRY
    actionsCountry({ commit }, axios) {
      commit("COUNTRY", axios);
    },
    actionsCountryList({ commit }, axios) {
      commit("COUNTRY_LIST", axios);
    },
    actionsCreateCountry({ commit }, payload) {
      commit("CREATE_COUNTRY", payload);
    },
    actionsEditCountry({ commit }, payload) {
      commit("EDIT_COUNTRY", payload);
    },
    actionsDeleteCountry({ commit }, payload) {
      commit("DELETE_COUNTRY", payload);
    },
    // END COUNTRY

    // REGION
    actionsRegion({ commit }, axios) {
      commit("REGION", axios);
    },
    actionsRegionList({ commit }, axios) {
      commit("REGION_LIST", axios);
    },
    actionsRegionFilter({ commit }, payload) {
      commit("REGION_FILTER", payload);
    },
    actionsCreateRegion({ commit }, payload) {
      commit("CREATE_REGION", payload);
    },
    actionsEditRegion({ commit }, payload) {
      commit("EDIT_REGION", payload);
    },
    actionsDeleteRegion({ commit }, payload) {
      commit("DELETE_REGION", payload);
    },
    // END REGION

    // CITY
    actionsCity({ commit }, axios) {
      commit("CITY", axios);
    },
    actionsCityList({ commit }, axios) {
      commit("CITY_LIST", axios);
    },
    actionsCityFilter({ commit }, payload) {
      commit("CITY_FILTER", payload);
    },
    actionsCreateCity({ commit }, payload) {
      commit("CREATE_CITY", payload);
    },
    actionsEditCity({ commit }, payload) {
      commit("EDIT_CITY", payload);
    },
    actionsDeleteCity({ commit }, payload) {
      commit("DELETE_CITY", payload);
    },
    // END CITY

    // ADDRESS
    actionsAddress({ commit }, axios) {
      commit("ADDRESS", axios);
    },
    actionsAddressList({ commit }, axios) {
      commit("ADDRESS_LIST", axios);
    },
    actionsAddressFilter({ commit }, payload) {
      commit("ADDRESS_FILTER", payload);
    },
    actionsCreateAddress({ commit }, payload) {
      commit("CREATE_ADDRESS", payload);
    },
    actionsEditAddress({ commit }, payload) {
      commit("EDIT_ADDRESS", payload);
    },
    actionsDeleteAddress({ commit }, payload) {
      commit("DELETE_ADDRESS", payload);
    },
    // END ADDRESS

    // IMAGES
    actionsCreateImages({ commit }, payload) {
      commit("CREATE_IMAGES", payload);
    },
    actionsCreateImage({ commit }, payload) {
      commit("CREATE_IMAGE", payload);
    },
    actionsDeleteImages({ commit }, payload) {
      commit("DELETE_IMAGES", payload);
    },
    // END IMAGES

    // MANAGER
    actionsManager({ commit }, axios) {
      commit("MANAGER", axios);
    },
    actionsManagerList({ commit }, payload) {
      commit("MANAGER_LIST", payload);
    },
    // actionsManagerFilter({commit}, payload) {
    //   commit('MANAGER_FILTER', payload)
    // },
    actionsCreateManager({ commit }, payload) {
      commit("CREATE_MANAGER", payload);
    },
    actionsEditManager({ commit }, payload) {
      commit("EDIT_MANAGER", payload);
    },
    actionsDeleteManager({ commit }, payload) {
      commit("DELETE_MANAGER", payload);
    },
    // END MANAGER

    // COMMERCIAL
    actionsCommercial({ commit }, axios) {
      commit("COMMERCIAL", axios);
    },
    actionsCommercialList({ commit }, axios) {
      commit("COMMERCIAL_LIST", axios);
    },
    actionsCommercialCompanyList({ commit }, payload) {
      commit("COMMERCIAL_COMPANY_LIST", payload);
    },
    actionsCommercialFilter({ commit }, payload) {
      commit("COMMERCIAL_FILTER", payload);
    },
    actionsCreateCommercial({ commit }, payload) {
      commit("CREATE_COMMERCIAL", payload);
    },
    actionsEditCommercial({ commit }, payload) {
      commit("EDIT_COMMERCIAL", payload);
    },
    actionsDeleteCommercial({ commit }, payload) {
      commit("DELETE_COMMERCIAL", payload);
    },
    // END COMMERCIAL

    // FEEDBACK
    actionsFeedback({ commit }, axios) {
      commit("FEEDBACK", axios);
    },
    actionsFeedbackList({ commit }, axios) {
      commit("FEEDBACK_LIST", axios);
    },
    actionsFeedbackFilter({ commit }, payload) {
      commit("FEEDBACK_FILTER", payload);
    },
    actionsEditFeedback({ commit }, payload) {
      commit("EDIT_FEEDBACK", payload);
    },
    // END FEEDBACK

    // MAINTENANCE
    actionsMaintenance({ commit }, axios) {
      commit("MAINTENANCE", axios);
    },
    actionsMaintenanceList({ commit }, axios) {
      commit("MAINTENANCE_LIST", axios);
    },
    actionsCreateMaintenance({ commit }, payload) {
      commit("CREATE_MAINTENANCE", payload);
    },
    actionsEditMaintenance({ commit }, payload) {
      commit("EDIT_MAINTENANCE", payload);
    },
    actionsDeleteMaintenance({ commit }, payload) {
      commit("DELETE_MAINTENANCE", payload);
    },
    // END MAINTENANCE

    // CURRENT VERSION
    actionsCurrentVersion({ commit }, axios) {
      commit("CURRENT_VERSION", axios);
    },
    actionsCurrentVersionList({ commit }, axios) {
      commit("CURRENT_VERSION_LIST", axios);
    },
    actionsCreateCurrentVersion({ commit }, payload) {
      commit("CREATE_CURRENT_VERSION", payload);
    },
    actionsEditCurrentVersion({ commit }, payload) {
      commit("EDIT_CURRENT_VERSION", payload);
    },
    actionsDeleteCurrentVersion({ commit }, payload) {
      commit("DELETE_CURRENT_VERSION", payload);
    },
    // END CURRENT VERSION

    // CLIENTTYPE
    actionsClientType({ commit }, axios) {
      commit("CLIENTTYPE", axios);
    },
    actionsClientTypeList({ commit }, axios) {
      commit("CLIENTTYPE_LIST", axios);
    },
    // actionsClientTypeFilter({commit}, payload) {
    //   commit('CLIENTTYPE_FILTER', payload)
    // },
    actionsCreateClientType({ commit }, payload) {
      commit("CREATE_CLIENTTYPE", payload);
    },
    actionsEditClientType({ commit }, payload) {
      commit("EDIT_CLIENTTYPE", payload);
    },
    actionsDeleteClientType({ commit }, payload) {
      commit("DELETE_CLIENTTYPE", payload);
    },
    // END CLIENTTYPE

    // DEAL
    actionsDeal({ commit }, axios) {
      commit("DEAL", axios);
    },
    actionsDealList({ commit }, axios, affiliate) {
      commit("DEAL_LIST", axios, affiliate);
    },
    // actionsDealFilter({commit}, payload) {
    //   commit('DEAL_FILTER', payload)
    // },
    actionsCreateDeal({ commit }, payload) {
      commit("CREATE_DEAL", payload);
    },
    actionsEditDeal({ commit }, payload) {
      commit("EDIT_DEAL", payload);
    },
    actionsDeleteDeal({ commit }, payload) {
      commit("DELETE_DEAL", payload);
    },
    // END DEAL

    // SubCategoryDesc
    actionsSubCategoryDesc({ commit }, axios) {
      commit("SUBCATEGORYDESC", axios);
    },
    actionsSubCategoryDescList({ commit }, axios) {
      commit("SUBCATEGORYDESC_LIST", axios);
    },
    // actionsDealFilter({commit}, payload) {
    //   commit('DEAL_FILTER', payload)
    // },
    actionsCreateSubCategoryDesc({ commit }, payload) {
      commit("CREATE_SUBCATEGORYDESC", payload);
    },
    actionsEditSubCategoryDesc({ commit }, payload) {
      commit("EDIT_SUBCATEGORYDESC", payload);
    },
    actionsDeleteSubCategoryDesc({ commit }, payload) {
      commit("DELETE_SUBCATEGORYDESC", payload);
    },
    // END SubCategoryDesc

    // CouponOff
    actionsCouponOff({ commit }, axios) {
      commit("COUPONOFF", axios);
    },
    actionsCouponOffList({ commit }, axios) {
      commit("COUPONOFF_LIST", axios);
    },
    actionsCreateCouponOff({ commit }, payload) {
      commit("CREATE_COUPONOFF", payload);
    },
    actionsEditCouponOff({ commit }, payload) {
      commit("EDIT_COUPONOFF", payload);
    },
    actionsDeleteCouponOff({ commit }, payload) {
      commit("DELETE_COUPONOFF", payload);
    },
    // END CouponOff

    // SERVICE
    actionsService({ commit }, axios) {
      commit("SERVICE", axios);
    },
    actionsServiceList({ commit }, axios) {
      commit("SERVICE_LIST", axios);
    },
    // actionsDealFilter({commit}, payload) {
    //   commit('DEAL_FILTER', payload)
    // },
    actionsCreateService({ commit }, payload) {
      commit("CREATE_SERVICE", payload);
    },
    actionsEditService({ commit }, payload) {
      commit("EDIT_SERVICE", payload);
    },
    actionsDeleteService({ commit }, payload) {
      commit("DELETE_SERVICE", payload);
    },
    // END SERVICE

    // NotificationBody
    actionsNotificationBody({ commit }, axios) {
      commit("NOTIFICATIONBODY", axios);
    },
    actionsNotificationBodyList({ commit }, axios) {
      commit("NOTIFICATIONBODY_LIST", axios);
    },
    // actionsClientTypeFilter({commit}, payload) {
    //   commit('CLIENTTYPE_FILTER', payload)
    // },
    actionsCreateNotificationBody({ commit }, payload) {
      commit("CREATE_NOTIFICATIONBODY", payload);
    },
    actionsEditNotificationBody({ commit }, payload) {
      commit("EDIT_NOTIFICATIONBODY", payload);
    },
    actionsDeleteNotificationBody({ commit }, payload) {
      commit("DELETE_NOTIFICATIONBODY", payload);
    },
    // END NotificationBody

    // NotificationSent
    actionsNotificationSent({ commit }, payload) {
      commit("NOTIFICATIONSENT", payload);
    },
    actionsNotificationSentList({ commit }, axios) {
      commit("NOTIFICATIONSENT_LIST", axios);
    },
    actionsNotificationSentFromClientList({ commit }, payload) {
      commit("NOTIFICATIONSENT_FROMCLIENT_LIST", payload);
    },
    // END NotificationSent

    actionsImageFilter({ commit }, payload) {
      commit("FILTER_IMAGE", payload);
    },
    actionsImageIdListFilter({ commit }, payload) {
      commit("IMAGE_ID_LIST", payload);
    },

    // GlobalConfiguration
    actionsGlobalConfiguration({ commit }, axios) {
      commit("GLOBAL_CONFIGURATION", axios);
    },
    actionsGlobalConfigurationList({ commit }, axios) {
      commit("GLOBAL_CONFIGURATION_LIST", axios);
    },
    actionsCreateGlobalConfiguration({ commit }, payload) {
      commit("CREATE_GLOBAL_CONFIGURATION", payload);
    },
    actionsEditGlobalConfiguration({ commit }, payload) {
      commit("EDIT_GLOBAL_CONFIGURATION", payload);
    },
    actionsDeleteGlobalConfiguration({ commit }, payload) {
      commit("DELETE_GLOBAL_CONFIGURATION", payload);
    },
    // END GlobalConfiguration

    // Meta
    actionsMeta({ commit }, axios) {
      commit("META", axios);
    },
    actionsMetaList({ commit }, axios) {
      commit("META_LIST", axios);
    },
    actionsDeleteMeta({ commit }, payload) {
      commit("DELETE_META", payload);
    },

    // MetaGroup
    actionsMetaGroup({ commit }, axios) {
      commit("METAGROUP", axios);
    },
    actionsMetaGroupList({ commit }, axios) {
      commit("METAGROUP_LIST", axios);
    },
    actionsDeleteMetaGroup({ commit }, payload) {
      commit("DELETE_METAGROUP", payload);
    },

    // MetaSeller
    actionsMetaSeller({ commit }, axios) {
      commit("METASELLER", axios);
    },
    actionsMetaSellerList({ commit }, axios) {
      commit("METASELLER_LIST", axios);
    },
    actionsDeleteMetaSeller({ commit }, payload) {
      commit("DELETE_METASELLER", payload);
    },

    // Seller
    actionsSeller({ commit }, axios) {
      commit("SELLER", axios);
    },
    actionsSellerList({ commit }, axios) {
      commit("SELLER_LIST", axios);
    },
    actionsDeleteSeller({ commit }, payload) {
      commit("DELETE_SELLER", payload);
    },
  },
  getters: {
    // AUTH
    getToken: (state) => {
      return state.token;
    },
    getMe: (state) => {
      return state.userId;
    },
    getRefreshToken: () =>{
      return localStorage.getItem('refreshToken')
    },
    // END AUTH

    // COMMON
    getOk: (state) => {
      return state.ok;
    },
    getErrorMessage: (state) => {
      return state.errorMessage;
    },
    getHasPermissionToView: (state) => {
      return state.hasPermissionToView;
    },
    getHasPermissionToCreate: (state) => {
      return state.hasPermissionToCreate;
    },
    getHasPermissionToUpdate: (state) => {
      return state.hasPermissionToUpdate;
    },
    getHasPermissionToDelete: (state) => {
      return state.hasPermissionToDelete;
    },
    getIsEmployment: (state) => {
      return state.isEmployment;
    },
    getIsManager: (state) => {
      return state.isManager;
    },
    getAppNames: (state) => {
      return state.appNames;
    },
    // END COMMON

    // USER
    getCurrentUser: (state) => {
      return state.currentUser;
    },
    getUser: (state) => {
      return state.user;
    },
    getUserList: (state) => {
      return state.userList;
    },
    // END USER

    // GROUP
    getGroup: (state) => {
      return state.group;
    },
    getGroupList: (state) => {
      return state.groupList;
    },
    // END GROUP

    // PERMISSION
    getPermissionList: (state) => {
      return state.permissionList;
    },
    // END PERMISSION

    // COUPON
    getCoupon: (state) => {
      return state.coupon;
    },
    getCouponNoUseList: (state) => {
      return state.couponNoUseList;
    },
    getCouponList: (state) => {
      return state.couponList;
    },
    // END COUPON
    // PROMOTION
    getPromotionList: (state) => {
      return state.promotionList;
    },
    getPromotion: (state) => {
      return state.promotion;
    },
    // END PROMOTION
    // LOYALTY CAMPAING
    getLoyaltyCampaingList: (state) => {
      return state.loyaltyCampaingList;
    },
    getLoyaltyCampaing: (state) => {
      return state.loyaltyCampaing;
    },
    getLoyaltyCampaingUsersList: (state) => {
      return state.loyaltyCampaingUsersList;
    },
    // END LOYALTY CAMPAING
    // COUPON WELCOME
    getCouponWelcome: (state) => {
      return state.couponWelcome;
    },
    getCouponWelcomeList: (state) => {
      return state.couponWelcomeList;
    },
    // END COUPON WELCOME

    // COUPON REFERENCE
    getCouponReference: (state) => {
      return state.couponReference;
    },
    getCouponReferenceList: (state) => {
      return state.couponReferenceList;
    },
    // END COUPON REFERENCE

    // COUPON REFERER
    getCouponReferer: (state) => {
      return state.couponReferer;
    },
    getCouponRefererList: (state) => {
      return state.couponRefererList;
    },
    // END COUPON REFERER

    // COUPONS
    getCoupons: (state) => {
      return state.coupons;
    },
    getCouponsList: (state) => {
      return state.couponsList;
    },
    // END COUPONS
    // RAFFLES
    getRafflesList: (state) => {
      return state.rafflesList;
    },
    getRaffles: (state) => {
      return state.raffles;
    },
    //END RAFFLES
    // COMPANY
    getCompany: (state) => {
      return state.company;
    },
    getCompanyList: (state) => {
      return state.companyList;
    },
    // END COMPANY

    // BRANCH OFFICE
    getBranchOffice: (state) => {
      return state.branchOffice;
    },
    getBranchOfficeList: (state) => {
      return state.branchOfficeList;
    },
    // END BRANCH OFFICE

    // CATEGORY
    getCategory: (state) => {
      return state.category;
    },
    getCategoryList: (state) => {
      return state.categoryList;
    },
    // END CATEGORY

    // PAYMENT
    getPayment: (state) => {
      return state.payment;
    },
    getPaymentList: (state) => {
      return state.paymentList;
    },
    getPaymentFilterList: (state) => {
      return state.paymentFilterList;
    },
    // END PAYMENT

    // ORDER
    getOrder: (state) => {
      return state.order;
    },
    getOrderList: (state) => {
      return state.orderList;
    },
    // END ORDER

    // COUPON USE
    getCouponUse: (state) => {
      return state.couponUse;
    },
    getCouponUseList: (state) => {
      return state.couponUseList;
    },
    getUses: (state) => {
      return state.getUses;
    },
    // END COUPON USE

    // EMPLOYMENT
    getEmployment: (state) => {
      return state.employment;
    },
    getEmploymentList: (state) => {
      return state.employmentList;
    },
    // END EMPLOYMENT

    // COUNTRY
    getCountry: (state) => {
      return state.country;
    },
    getCountryList: (state) => {
      return state.countryList;
    },
    // END COUNTRY

    // REGION
    getRegion: (state) => {
      return state.region;
    },
    getRegionList: (state) => {
      return state.regionList;
    },
    // END REGION

    // CITY
    getCity: (state) => {
      return state.city;
    },
    getCityList: (state) => {
      return state.cityList;
    },
    // END CITY

    // ADDRESS
    getAddressId: (state) => {
      return state.addressId;
    },
    getAddress: (state) => {
      return state.address;
    },
    getAddressList: (state) => {
      return state.addressList;
    },
    // END ADDRESS

    // IMAGES
    getImagesIds: (state) => {
      return state.imagesIds;
    },
    getImageId: (state) => {
      return state.imageId;
    },
    getImageIdList: (state) => {
      return state.imageIdList;
    },
    // END IMAGES

    // MANAGER
    getManager: (state) => {
      return state.manager;
    },
    getManagerList: (state) => {
      return state.managerList;
    },
    // END MANAGER

    // COMMERCIAL
    getCommercial: (state) => {
      return state.commercial;
    },
    getCommercialList: (state) => {
      return state.commercialList;
    },
    // END COMMERCIAL

    // FEEDBACK
    getFeedback: (state) => {
      return state.feedback;
    },
    getFeedbackList: (state) => {
      return state.feedbackList;
    },
    getFeedbackStates: (state) => {
      return state.feedbackStates;
    },
    // END FEEDBACK

    // MAINTENANCE
    getMaintenance: (state) => {
      return state.maintenance;
    },
    getMaintenanceList: (state) => {
      return state.maintenanceList;
    },
    // END MAINTENANCE

    // CURRENT VERSION
    getCurrentVersion: (state) => {
      return state.currentVersion;
    },
    getCurrentVersionList: (state) => {
      return state.currentVersionList;
    },
    // END CURRENT VERSION
    getCityToCoupons: (state) => {
      return state.cityToCoupons;
    },
    // GlobalConfiguration
    getGlobalConfiguration: (state) => {
      return state.globalConfiguration;
    },
    getGlobalConfigurationList: (state) => {
      return state.globalConfigurationList;
    },
    // END GlobalConfiguration
    // Meta
    getMeta: (state) => {
      return state.meta;
    },
    getMetaList: (state) => {
      return state.metaList;
    },
    // MetaGroup
    getMetaGroup: (state) => {
      return state.metaGroup;
    },
    getMetaGroupList: (state) => {
      return state.metaGroupList;
    },
    // MetaSeller
    getMetaSeller: (state) => {
      return state.metaSeller;
    },
    getMetaSellerList: (state) => {
      return state.metaSellerList;
    },
    // Seller
    getSeller: (state) => {
      return state.seller;
    },
    getSellerList: (state) => {
      return state.sellerList;
    },
  },
  plugins: [vuexLocal.plugin],
});
